// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"97bc8511","153":"c96710d8","235":"bf42e7e0","240":"c3356d0b","400":"ca437c2a","463":"fe419230","477":"96de7a84","513":"f4c14270","722":"d33a31f2","742":"375c3269","753":"9068f930","787":"4c72bb55","828":"4f194284"}[chunkId] + ".chunk.js";
};